<template>
  <v-container>
    <v-card class="pa-16">
      <v-row>
        <v-col cols="12" md="4">
          <v-card-title class="text-h5">Leave Quota List</v-card-title>
        </v-col>
        <v-col align="right" color="primary" cols="12" md="8">
          <v-row class="justify-end">
            <v-btn
              rounded
              outlined
              class="red mb-2 ml-2"
              style="color: white"
              @click="openClosePeriod()"
            >
              <span>Close Period</span>
            </v-btn>
            <v-btn to="/import-leave-quota" rounded dark class="mb-2 ml-2">
              <span>Import</span>
              <v-icon small center>mdi-download</v-icon>
            </v-btn>
            <!-- <v-btn rounded outlined class="mb-2 ml-2" :href='`${linkdownloadleavequota}`' download>
              <span>Download Template</span>
              <v-icon small center>mdi-upload</v-icon>
            </v-btn> -->
            <v-btn rounded outlined class="mb-2 ml-2" @click="loadTemplete()">
              <span>Download Template</span>
              <v-icon small center>mdi-upload</v-icon>
            </v-btn>
            <!-- <xlsx-workbook>
              <xlsx-sheet
                :collection="sheet.data"
                v-for="sheet in sheets"
                :key="sheet.name"
                :sheet-name="sheet.name"
              />
              <xlsx-download :filename="exportleavequota">
                <v-btn rounded outlined class="mb-2 ml-2">
                  <span>Export</span>
                  <v-icon small center>mdi-upload</v-icon>
                </v-btn>
              </xlsx-download>
            </xlsx-workbook> -->

            <v-btn
              to="/new-leave-quota"
              color="#0A7EA5"
              rounded
              dark
              class="mb-2 ml-2"
            >
              <span>Add</span>
              <v-icon small center>add</v-icon>
            </v-btn>
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="4">
          <v-text-field
            class="widthsizesearch"
            v-model="search"
            append-icon="mdi-magnify"
            :label="setlanguage.labelsearch"
            single-line
            hide-details
            outlined
            dense
            style="margin-left: 1rem"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="7" class="d-flex justify-end mb-6" offset="1">
          <v-row>
            <v-col cols="4" xl="4" lg="4" md="4">
              <v-menu
                v-model="menu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="computedDateFromFormatted"
                    label="Date From"
                    append-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    dense
                    clearable
                    @click:clear="
                      $nextTick(() => {
                        datefrom = null;
                        dateto = null;
                      })
                    "
                    @input="loaddatadetails"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="datefrom"
                  @input="menu = false"
                  @change="loaddatadetails"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="4" xl="4" lg="4" md="4">
              <v-menu
                v-model="menu2"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="computedDateToFormatted"
                    label="Date To"
                    append-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    dense
                    clearable
                    @click:clear="
                      $nextTick(() => {
                        datefrom = null;
                        dateto = null;
                      })
                    "
                    @input="loaddatadetails"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="dateto"
                  @input="menu2 = false"
                  @change="loaddatadetails"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col align="right" cols="4" xl="4" lg="4" md="4">
              <v-autocomplete
                v-model="search_status"
                :items="status_list"
                item-text="name"
                item-value="value"
                label="Status"
                outlined
                dense
                @change="loaddatadetails"
                clearable
                @click:clear="
                  $nextTick(() => {
                    search_status = '';
                  })
                "
              ></v-autocomplete>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <!-- <v-row v-show="toggleEnable">
        <v-col cols="6"> </v-col>
        <v-col cols="2" xl="2" lg="2" md="2">
          <v-menu
            v-model="menu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="computedDateFromFormatted"
                label="Date From"
                append-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
                outlined
                dense
                clearable
                @click:clear="
                          $nextTick(() => {
                            datefrom = null;
                            dateto = null;
                          })
                        "
                @input="finddatafromdate"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="datefrom"
              @input="menu = false"
              @change="finddatafromdate"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="2" xl="2" lg="2" md="2">
          <v-menu
            v-model="menu2"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="computedDateToFormatted"
                label="Date To"
                append-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
                outlined
                dense
                clearable
                @click:clear="
                          $nextTick(() => {
                            datefrom = null;
                            dateto = null;
                          })
                        "
                @input="finddatafromdate"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="dateto"
              @input="menu2 = false"
              @change="finddatafromdate"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col align="right" cols="2" xl="2" lg="2" md="2">
          <v-autocomplete
            v-model="search_status"
            :items="status"
            label="Status"
            outlined
            dense
            @change="findChaege"
            clearable
            @click:clear="
                          $nextTick(() => {
                            search_status = '';
                          })
                        "
          ></v-autocomplete>
        </v-col>
      </v-row> -->

      <br />

      <v-card outlined tile>
        <v-data-table
          dense
          :search="search"
          :headers="headers"
          :items="mDataArray"
          class="elevation-1 595959"
        >
          <template v-slot:[`item.actions`]="{ item }">
            <v-icon
              :style="{
                backgroundColor: '#E1F5FE',
                color: '#2196F3',
              }"
              @click="openeditItem(item)"
            >
              mdi-pencil
            </v-icon>

            <v-icon
              class="ml-3"
              :style="{
                backgroundColor: '#FFEBEE',
                color: '#F44336',
              }"
              @click="deleteItem(item)"
            >
              mdi-delete
            </v-icon>
          </template>
          <!--     <template v-slot:[`item.actions`]="{ item }">
            <v-icon small class="mr-2" @click="editItem(item)">
              mdi-pencil
            </v-icon>
            <v-icon small @click="deleteItem(item)">
              mdi-delete
            </v-icon>
          </template> -->
        </v-data-table>
      </v-card>

      <v-dialog v-model="dialogDelete" width="unset">
        <v-card
          style="padding-top: 30px; padding-bottom: 30px; min-width: 400px"
        >
          <v-card-title style="padding-bottom: 20px">
            <v-row justify="center">
              <span class="red--text text-h5 ju">Are you sure?</span>
            </v-row>
          </v-card-title>
          <br />
          <v-card-subtitle>
            <v-row justify="center">
              <span class="black--text"
                >Are you sure you want to delete this item</span
              >
            </v-row>
          </v-card-subtitle>
          <v-card-actions class="d-flex justify-center">
            <v-btn
              style="color: white"
              class="mr-5"
              color="green"
              @click="deleteItemConfirm"
              width="120"
            >
              Save
            </v-btn>
            <v-btn
              style="color: white"
              class="mr-5"
              color="red"
              @click="closeDelete"
              width="120"
            >
              Cancel
            </v-btn>
            <!-- <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
            <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn> -->
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogClosePeriod" max-width="600px">
        <v-card>
          <v-card-title class="d-flex justify-center pt-16 pb-10 text-h5">
            <span class="pr-2">Close Period</span>
            <v-tooltip bottom max-width="350">
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  color="blue"
                  v-bind="attrs"
                  v-on="on"
                  dark
                  class="custom-icon"
                  >mdi-help-circle</v-icon
                >
              </template>
              <!-- <v-card > -->

              <v-card-text>
                The leave quota is finalized at the end of each period (e.g.,
                year or quarter). After submitting this "close period," no
                further leave requests from that period can be processed, and
                unused leave may expire or carry over based on company policy.
              </v-card-text>

              <!-- </v-card> -->
            </v-tooltip>
          </v-card-title>
          <v-card-text class="text-h6" style="margin: -40px 0 -30px 0">
            <v-row>
              <v-col cols="12" md="4" offset="2">
                <span>From</span>
                <v-menu
                  v-model="menuCPfrom"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="periodC_datefrom"
                      class="pt-2"
                      append-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      outlined
                      dense
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="periodC_datefrom"
                    @input="menuCPfrom = false"
                    @change="ckeckperiod"
                  ></v-date-picker>
                </v-menu>
              </v-col>

              <v-col cols="12" md="4">
                <span>To</span>
                <v-menu
                  v-model="menuCPto"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      class="pt-2"
                      v-model="periodC_dateto"
                      append-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      outlined
                      dense
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="periodC_dateto"
                    @input="menuCPto = false"
                    @change="ckeckperiod"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="d-flex justify-center pt-10 pb-16">
            <v-btn
              style="color: white"
              rounded
              class="mr-5"
              color="#0A7EA5"
              @click="saveCloesPeriod"
              width="180"
            >
              Submit
            </v-btn>
            <v-btn
              style="color: white"
              class="mr-5"
              color="red"
              @click="closedialogClosePeriod"
              width="180"
              rounded
            >
              Cancel
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <SuccessDialog
        :status="dialogAdd"
        :text_color="text_color"
        :title="title"
        :message="message"
      />

      <SuccessDialogPush
        :status="dialogAdd"
        :text_color="text_color"
        :title="title"
        :message="message"
        :link="link"
      />
    </v-card>
  </v-container>
</template>

<script>
import SuccessDialog from "@/components/cards/SuccessDialog";
import api from "@/services/api";
import { server, leavequotaFile,apiUrl } from "@/services/constants";
import { language } from "./language/Advancelist.js";
import { tolocalestringnumber } from "./computing/tolocalestringnumber";
import {
  XlsxRead,
  XlsxTable,
  XlsxSheets,
  XlsxJson,
  XlsxWorkbook,
  XlsxSheet,
  XlsxDownload,
} from "vue-xlsx";
import unity from "@/unity/unity";

export default {
  name: "advance-list",
  components: {
    XlsxRead,
    XlsxTable,
    XlsxSheets,
    XlsxJson,
    XlsxWorkbook,
    XlsxSheet,
    XlsxDownload,
  },
  data(vm) {
    const year = new Date().getFullYear();
    return {
      linkdownloadleavequota: ``,
      search_status: "",
      exportleavequota: "leavequota.xlsx",
      sheetName: "leavequota",
      sheets: [
        {
          name: "leavequota",
          data: [],
        },
      ],
      collection: [{ a: 1, b: 2 }],
      deletedItem_id: 0,
      deletedItem: {
        employee_id: 0,
        leave_period_from: "",
        leave_period_to: "",
      },
      menu: false,
      menu2: false,
      menuCPfrom: false,
      menuCPto: false,
      search: "",
      toggleEnable: false,
      selectstatus: "",
      dataAll: [],
      status_list: [
        { name: "Active", value: "A" },
        { name: "Inactive", value: "I" },
      ],
      // datefrom: null,
      // dateto: null,
      datefrom: `${year}-01-01`,
      dateto: `${year}-12-31`,
      // datefrom: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      //   .toISOString()
      //   .substr(0, 10),
      // dateto: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      //   .toISOString()
      //   .substr(0, 10),
      periodC_datefrom: vm.formatDate(new Date().toISOString().substr(0, 10)),
      periodC_dateto: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      periodD_datefrom: vm.formatDate(new Date().toISOString().substr(0, 10)),
      periodD_dateto: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      dateCurrent: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      seticonsearchmore: { icon: "mdi mdi-chevron-down", action: false },
      setlanguage: language.en,
      defaultlanguage: "en",
      // regexlang: "th",
      chooselanguage: [
        { name: "en", flag: "gb" },
        { name: "th", flag: "th" },
      ],
      aa: "สวัสดี",
      dialogEdit: false,
      dialogDelete: false,
      dialogClosePeriod: false,
      mDataArray: [],
      position: [],
      approver: [],
      department: [],
      department_list: [],
      position_list: [],
      company: [],
      authorize: [],
      headers: [
        { text: "Department", value: "company_name" },
        { text: "Employee ID", value: "employee_id" },
        { text: "Employee Name", value: "employee_name" },
        { text: "Period", value: "period" },
        { text: "Status", value: "status" },
        { text: "", value: "actions" },
      ],
      dialogAdd: false,
      text_color: "text-h5 green--text text-center",
      title: "green",
      message: "green",
      link: "",
    };
  },
  components: {
    SuccessDialog,
  },
  async beforeCreate() {
    //console.log("beforeCreate");
    this.$store.state.navMenu = true;
  },
  async created() {},
  beforeUpdate() {},
  computed: {
    itemsForSelected() {
      if (this.search.length) {
        return this.dataSource.filter((item) => this.search.includes(item));
      }
      return this.dataSource;
    },
    computedDateFromFormatted() {
      return unity.formatDate(this.datefrom);
    },
    computedDateToFormatted() {
      return unity.formatDate(this.dateto);
    },
  },
  async mounted() {
    await api.checkVersion();
    this.userId = localStorage.getItem(server.USER_ID);
    let yourUrlString = window.location;
    // alert(yourUrlString);

    let parser = document.createElement("a");
    parser.href = yourUrlString;

    this.authorize_id = localStorage.getItem(server.AUTHORIZE_ID);

    // alert("authorize_id:" + this.authorize_id);
    if (this.authorize_id == null || this.authorize_id == 0) {
      // this.$router.push("/login");
      this.$store.state.global_dialog = true;
      this.setupAlertDialog(
        true,
        "Authorize Failed",
        "Please Logout And Login Again",
        "text-h5 red--text text-center"
      );
      this.$router.back();
    }

    const router_path = parser.pathname.replace("/", "");

    const res_auth = await api.getAuthorize(this.userId, router_path);

    // console.log("res_auth:" + JSON.stringify(res_auth.data));

    this.authorize_view = res_auth.data[0].smd_view >= 1 ? true : false;
    this.authorize_add = res_auth.data[0].smd_add >= 1 ? true : false;
    this.authorize_edit = res_auth.data[0].smd_edit >= 1 ? true : false;
    this.authorize_del = res_auth.data[0].smd_del >= 1 ? true : false;

    // this.$router.back();

    if (!this.authorize_view) {
      this.$router.push("/not-found");
    }

    // ----------------- Check Authorize ---------------------------

    let comp_id = localStorage.getItem(server.COMPANYID);
    // await this.loadCompanyMaster(comp_id);
    // await this.loadDepartmentMaster(comp_id);
    // await this.loadPositionMaster(comp_id);

    await this.loadAuthorize();
    await this.loaddatadetails();
    this.linkdownloadleavequota = `${apiUrl}/leavequota/leavequota_template.xlsx`;

    this.userId = localStorage.getItem(server.USER_ID);
    if (this.userId && api.isLoggedIn()) {
      // this.$router.push("/");
    } else {
      this.$store.state.isLogged = false;
      this.$router.push("/login");
    }
  },
  methods: {
    async loadTemplete() {
      // แก้ไขชื่อฟังก์ชันให้ถูกต้อง
      try {
        const res_temp = await api.createLeaveTeplete({
          params: {
            company_id: localStorage.getItem(server.COMPANYID),
          },
        });

        if (res_temp.status === 201 && res_temp.data.length > 0) {
          const delay = (delayInms) => {
            return new Promise((resolve) => setTimeout(resolve, delayInms));
          };

          const downloaddata = async () => {
            this.$showLoader();
            await delay(2000);
            
            window.open(`${apiUrl}/leavequota/leavequota_template.xlsx`, `_blank`); // เปิดแท็บใหม่
            this.$hideLoader();
            await delay(2000);
            await api.removeLeaveTeplete();
          };

          downloaddata();
        } else {
          console.error("Template creation failed or no data returned.");
        }
      } catch (error) {
        console.error("An error occurred while loading template:", error);
      }
    },

    openeditItem(item) {
      this.$router.push(
        `/edit-leave-quota/${item.employee_id}/${item.period_datefrom}/${item.period_dateto}`
      );
    },
    async openClosePeriod() {
      this.dialogClosePeriod = true;
    },
    async closedialogClosePeriod() {
      this.dialogClosePeriod = false;
      this.periodC_datefrom = this.periodD_datefrom;
      this.periodC_dateto = this.periodD_dateto;
    },
    deleteItem(item) {
      // this.editedIndex = this.desserts.indexOf(item);
      // this.editedItem = Object.assign({}, item);
      this.deletedItem_id = item.employee_id;
      this.deletedItem.employee_id = item.employee_id;
      this.deletedItem.leave_period_from = item.period_datefrom;
      this.deletedItem.leave_period_to = item.period_dateto;
      this.dialogDelete = true;
    },
    closeDelete() {
      this.deletedItem_id = 0;
      this.deletedItem = {
        employee_id: 0,
        leave_period_from: "",
        leave_period_to: "",
      };
      this.dialogDelete = false;
    },
    ckeckperiod() {
      if (this.periodC_datefrom > this.periodC_dateto) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Period From > Period To",
          "text-h5 red--text text-center"
        );
        return;
      }
    },
    findChaege() {
      // alert(this.search_status)
      this.mDataArray = this.dataAll.filter((item) => {
        if (this.datefrom == null || this.dateto == null) {
          if (this.search_status != null) {
            if (item.status == this.search_status) {
              return item;
            }
          } else {
            return item;
          }
        }
        if (this.datefrom != null && this.dateto != null) {
          if (this.search_status != null) {
            if (
              item.status == this.search_status &&
              item.period_datefrom >= this.datefrom &&
              item.period_dateto <= this.dateto
            ) {
              return item;
            }
          } else {
            if (
              item.period_datefrom >= this.datefrom &&
              item.period_dateto <= this.dateto
            ) {
              return item;
            }
          }
        }
      });
    },
    async saveCloesPeriod() {
      if (this.periodC_datefrom > this.periodC_dateto) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Period From > Period To",
          "text-h5 red--text text-center"
        );
        return;
      }
      const updatecloseperiod = await api.updateCloseLeaveQuota(
        this.periodC_datefrom,
        this.periodC_dateto
      );
      // console.log("updatecloseperiod.data:");
      // console.log(updatecloseperiod);
      if (updatecloseperiod.status == 200 || updatecloseperiod.status == 201) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Information Saved",
          "Information successfully saved",
          "text-h5 green--text text-center"
        );
        this.closedialogClosePeriod();
        return;
      } else {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Information Saved",
          "ไม่สามารถบันทึกได้",
          "text-h5 red--text text-center"
        );
        this.closedialogClosePeriod();
        return;
      }
    },
    async deleteItemConfirm() {
      // this.desserts.splice(this.editedIndex, 1);
      const resdel = await api.deleteLeave_quota(this.deletedItem);
      if (resdel.data[0].status == 1) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "ไม่สามารถลบข้อมูลได้",
          "มีการใช้งาน  LeaveQuota นี้อยู่",
          "text-h5 red--text text-center"
        );
      } else {
        if (resdel.data[0].status == 0) {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "ลบข้อมูล",
            "ลบข้อมูลสำเร็จ",
            "text-h5 green--text text-center"
          );
        } else {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "ลบข้อมูล",
            "ลบข้อมูลไม่สำเร็จ",
            "text-h5 red--text text-center"
          );
        }
      }
      this.loaddatadetails();
      this.closeDelete();
      this.closedialogClosePeriod();
    },

    showsearchmore() {
      this.toggleEnable = !this.toggleEnable;
      this.seticonsearchmore.action = !this.seticonsearchmore.action;
      if (this.seticonsearchmore.action === true) {
        this.seticonsearchmore.icon = "mdi mdi-chevron-up";
      } else {
        this.seticonsearchmore.icon = "mdi mdi-chevron-down";
      }
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    finddatafromdate() {
      this.mDataArray = this.dataAll.filter((item) => {
        if (this.search_status == "") {
          if (this.datefrom != null && this.dateto != null) {
            if (
              item.period_datefrom >= this.datefrom &&
              item.period_dateto <= this.dateto
            ) {
              return item;
            }
          }
          if (this.datefrom == null && this.dateto == null) {
            return item;
          }
        } else {
          if (this.datefrom != null && this.dateto != null) {
            if (
              item.period_datefrom >= this.datefrom &&
              item.period_dateto <= this.dateto &&
              item.status == this.search_status
            ) {
              return item;
            }
          }
          if (this.datefrom == null && this.dateto == null) {
            if (item.status == this.search_status) {
              return item;
            }
          }
        }
      });
    },
    onClicktoaddadvance(id) {
      this.$router.push(`/edit-advance/${id}/edit`);
    },

    async loadCompanyMaster(id) {
      const result = await api.getCompanyMaster(id);
      this.company = result.data;
    },

    async loadDepartmentMaster(id) {
      const result = await api.getDepartmentMaster(id);
      this.department = result.data;
      result.data.forEach((item) => {
        this.department_list.push(item.name);
      });
    },
    async loadAuthorize() {
      const res_get = await api.getSettingGroupMenu();
      // console.log("res loadAuthorize : ", JSON.stringify(res_get));
      this.authorize = res_get.data;
    },

    async loadPositionMaster(id) {
      const result = await api.getPositionMaster(id);
      // console.log("result.data : ", JSON.stringify(result.data));
      this.position = result.data;

      result.data.forEach((item) => {
        this.position_list.push(item.name);
      });
    },

    async loadDetailAccount(id) {
      // console.log("loadDetailAccount:", id + "//");
      const result = await api.getAccountDetail(id);
      // console.log("loadDetailAccount result: ", JSON.stringify(result));
      this.editedItem = Object.assign({}, result.data[0]);
    },
    async loaddatadetails() {
      this.$showLoader();
      // const result = await api.getAllleave_quota_By_Company(
      //   localStorage.getItem(server.COMPANYID)
      // );
      const result = await api.getAllleave_quota_By_List({
        params: {
          company_id: localStorage.getItem(server.COMPANYID),
          datefrom: this.datefrom,
          dateto: this.dateto,
          status: this.search_status,
        },
      });
      this.dataAll = result.data;

      this.mDataArray = this.dataAll;

      // const result_export = await api.getexportLeave_quota();
      // result_export.data.forEach((x) => {
      //   x.leave_period_from = new Date(x.leave_period_from);
      //   x.leave_period_to = new Date(x.leave_period_to);
      // });
      // this.sheets[0].data = result_export.data;
      // //console.log(this.approver)
      // result.data.forEach((item) => {
      //   this.approver.push(item.firstname);
      // });

      // this.$showLoader();
      this.$hideLoader();
    },
    setupAlertDialog(status, title, message, text_color) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
    },
  },
};
</script>

<style scoped>
.theme--light.v-card.redborder {
  border-color: red;
}
.widthsizesearch {
  width: 70%;
}
</style>
